import React from 'react';
import { useLwp } from '../../hooks/use-lwp';
import CallErrorNoMicPermissions from './call-error-no-mic-permissions';
import CallErrorNoMicrophone from './call-error-no-microphone';
import CallErrorUnknown from './call-error-unknown';

export default function CallWarnings() {
  const {
    phoneState: { error, phoneStatus }
  } = useLwp();

  if (error === 'nomicrophone' && phoneStatus === 'error') return <CallErrorNoMicrophone />;

  if (error === 'nomicpermissions' && phoneStatus === 'error') return <CallErrorNoMicPermissions />;

  if (error === 'noFeatureFlag' && phoneStatus === 'error')
    return <CallErrorUnknown message="Phone feature flag is disabled." />;

  if (phoneStatus == 'error') return <CallErrorUnknown />;

  return null;
}
